import type { PropsWithChildren } from 'react';
import { StyleSheetManager } from 'styled-components';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot,
  useFontsLoader
} from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import type { ButtonSettings } from './types';
import { Widget } from './widget/widget';

export function Button(_settings: ButtonSettings) {
  return (
    <ButtonProviders>
      <Widget />
    </ButtonProviders>
  );
}

function ButtonProviders({ children }: PropsWithChildren) {
  const { customCSS, customJS, editMode, font, renderThumbnailMode, widgetId } =
    useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    'button',
    widgetId
  );
  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);
  useFontsLoader([font]);

  return (
    <StyleSheetManager
      shouldForwardProp={(propName) => !propName.startsWith('_')}
    >
      <CustomCSS
        customCSS={customCSS}
        prefixClassName={customCSSPrefixClassName}
      />
      <EmbedRoot customCSSClassName={customCSSPrefixClassName}>
        {children}
      </EmbedRoot>
    </StyleSheetManager>
  );
}
